import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { toast } from 'sonner';
import { Plus, TrendingDown } from 'lucide-react';

const Gastos = () => {
  const [gastos, setGastos] = useState([]);
  const [gastosFurgon, setGastosFurgon] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('generales');
  const [formData, setFormData] = useState({ descripcion: '', categoria: 'combustible', monto: 0, fecha: new Date().toISOString().split('T')[0], tipo_gasto: 'operacional' });

  useEffect(() => {
    fetchGastos();
    fetchGastosFurgon();
  }, []);

  const fetchGastos = async () => {
    try {
      const response = await api.get('/expenses/gastos');
      setGastos(response.data || []);
    } catch (error) {
      toast.error('Error al cargar gastos');
    } finally {
      setLoading(false);
    }
  };

  const fetchGastosFurgon = async () => {
    try {
      const response = await api.get('/expenses/gastos-furgon');
      setGastosFurgon(response.data || []);
    } catch (error) {
      console.error('Error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/expenses', formData);
      toast.success('Gasto registrado');
      fetchGastos();
      setDialogOpen(false);
    } catch (error) {
      toast.error('Error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 pb-24">
      <div className="max-w-7xl mx-auto">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-2xl flex items-center"><TrendingDown className="mr-2" />Gastos</CardTitle>
              <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogTrigger asChild><Button><Plus className="mr-2 h-4 w-4" />Nuevo Gasto</Button></DialogTrigger>
                <DialogContent>
                  <DialogHeader><DialogTitle>Registrar Gasto</DialogTitle></DialogHeader>
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div><Label>Descripción *</Label><Input value={formData.descripcion} onChange={(e) => setFormData({...formData, descripcion: e.target.value})} required /></div>
                    <div><Label>Categoría</Label>
                      <Select value={formData.categoria} onValueChange={(value) => setFormData({...formData, categoria: value})}>
                        <SelectTrigger><SelectValue /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="combustible">Combustible</SelectItem>
                          <SelectItem value="mantenimiento">Mantenimiento</SelectItem>
                          <SelectItem value="alquiler">Alquiler</SelectItem>
                          <SelectItem value="servicios">Servicios</SelectItem>
                          <SelectItem value="materiales">Materiales</SelectItem>
                          <SelectItem value="otros">Otros</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div><Label>Monto *</Label><Input type="number" step="0.01" value={formData.monto} onChange={(e) => setFormData({...formData, monto: parseFloat(e.target.value) || 0})} required /></div>
                    <div><Label>Fecha</Label><Input type="date" value={formData.fecha} onChange={(e) => setFormData({...formData, fecha: e.target.value})} /></div>
                    <div className="flex justify-end space-x-2">
                      <Button type="button" variant="outline" onClick={() => setDialogOpen(false)}>Cancelar</Button>
                      <Button type="submit">Registrar</Button>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
            </div>
          </CardHeader>
          <CardContent>
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList><TabsTrigger value="generales">Gastos Generales</TabsTrigger><TabsTrigger value="furgon">Gastos de Furgón</TabsTrigger></TabsList>
              <TabsContent value="generales">
                {loading ? <div className="text-center py-8">Cargando...</div> : (
                  <Table>
                    <TableHeader><TableRow><TableHead>Fecha</TableHead><TableHead>Descripción</TableHead><TableHead>Categoría</TableHead><TableHead>Monto</TableHead></TableRow></TableHeader>
                    <TableBody>
                      {gastos.length === 0 ? <TableRow><TableCell colSpan={4} className="text-center">No hay gastos</TableCell></TableRow> : gastos.map((gasto) => (
                        <TableRow key={gasto.id}>
                          <TableCell>{gasto.fecha}</TableCell>
                          <TableCell className="font-medium">{gasto.descripcion}</TableCell>
                          <TableCell>{gasto.categoria}</TableCell>
                          <TableCell className="text-red-600 font-semibold">-${gasto.monto?.toFixed(2)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TabsContent>
              <TabsContent value="furgon">
                <Table>
                  <TableHeader><TableRow><TableHead>Furgón</TableHead><TableHead>Descripción</TableHead><TableHead>Categoría</TableHead><TableHead>Monto</TableHead></TableRow></TableHeader>
                  <TableBody>
                    {gastosFurgon.length === 0 ? <TableRow><TableCell colSpan={4} className="text-center">No hay gastos de furgón</TableCell></TableRow> : gastosFurgon.map((gasto) => (
                      <TableRow key={gasto.id}>
                        <TableCell className="font-medium">{gasto.numero_furgon}</TableCell>
                        <TableCell>{gasto.descripcion}</TableCell>
                        <TableCell>{gasto.categoria}</TableCell>
                        <TableCell className="text-red-600 font-semibold">-${gasto.monto?.toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Gastos;
